// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/manot-search-process.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/manot-search-process/manot-search-process.js';

mount([g0]);
